import { Suspense } from "react";
import { FadeLoader } from "react-spinners";
import ChunkErrorBoundary from "../common/ChunkErrorBoundary";

const PublicRoutesSuspense = ({ children }) => (
  <div className="top-fix-sec">
    <ChunkErrorBoundary>
      <Suspense
        fallback={
          <div className="loader-style container-fluid">
            <FadeLoader
              className="fade-loader"
              loading={true}
              color={"#D61F7F"}
            />
          </div>
        }
      >
        {children}
      </Suspense>
    </ChunkErrorBoundary>
  </div>
);

export default PublicRoutesSuspense;
